import React from 'react';
import CadastroCliente from './CadastroCliente';
import { cadastrarCliente } from '../services/api';

const NovoCliente = ({ token }) => {
  const handleSubmit = async (data) => {
    try {
      await cadastrarCliente(data, token);
    } catch (err) {
      const data = err?.response?.data;

      // quando o backend manda string (text/plain)
      if (typeof data === 'string') {
        alert(data);
        return;
      }

      // quando manda JSON com { message } ou ModelState
      const message =
        data?.message ||
        (data?.errors && Object.values(data.errors).flat().join('\n')) ||
        err.message ||
        'Erro ao salvar cliente.';

      alert(message);
      console.error(err);
    }

  };

  return (
    <CadastroCliente onSubmit={handleSubmit} token={token} />
  );
};

export default NovoCliente;
